export const PROBLEM_REPORT_CATEGORIES = [
	{ id: "bug", label: "Bug / something broke" },
	{ id: "confusing", label: "Confusing or hard to use" },
	{ id: "data_wrong", label: "Wrong or missing data" },
	{ id: "performance", label: "Slow or unresponsive" },
	{ id: "other", label: "Other" },
] as const;

export type ProblemReportCategory =
	(typeof PROBLEM_REPORT_CATEGORIES)[number]["id"];
